function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import { Provider } from 'react-redux';
import qs from 'qs';
import { ThemeProvider } from '4finance-components';
import { Provider as TranslateProvider } from '4finance-translate';
import { actions } from '4finance-translate';
import store from '../redux/configureStore';
import { setInitialState } from '../redux/actions';
import createExtendedTheme from '../styles/createExtendedTheme';
import RecoverStep from '../enums/recoverStep';
import RecoverType from '../enums/recoverType';
import defaultTranslations from '../localizations/defaults/en';
import PasswordRecovery from './PasswordRecovery';
var PasswordRecoveryApp = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PasswordRecoveryApp, _React$PureComponent);
  function PasswordRecoveryApp(props) {
    var _this;
    _classCallCheck(this, PasswordRecoveryApp);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(PasswordRecoveryApp).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      error: false
    });
    var recoverActivation = _this._getTokenAndCode();
    store.dispatch(setInitialState({
      apiUrl: props.apiUrl,
      phoneNumberFormat: props.phoneNumberFormat,
      captchaApiKey: props.captchaApiKey,
      captchaLanguage: props.captchaLanguage,
      recoverStep: RecoverStep.RECOVER_CHOICE,
      recoverType: recoverActivation.recoverType,
      recoverCode: recoverActivation.recoverCode,
      recoverToken: recoverActivation.recoverToken,
      attemptCount: 0,
      errorCode: '',
      isLoading: false,
      fieldsProps: props.fieldsProps
    }));
    store.dispatch(actions.updateMessages(props.translations));
    return _this;
  }
  _createClass(PasswordRecoveryApp, [{
    key: "_getTokenAndCode",
    value: function _getTokenAndCode() {
      if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
        var parsed = qs.parse(window.location.search, {
          ignoreQueryPrefix: true
        });
        if (parsed.token && parsed.code) return {
          recoverType: RecoverType.EMAIL_RECOVER,
          recoverToken: parsed.token,
          recoverCode: parsed.code
        };
      }
      return {
        recoverType: '',
        recoverToken: '',
        recoverCode: ''
      };
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      console.error('Password recovery crashed!', error);
      console.error('Error stack', errorInfo.componentStack);
      this.setState({
        error: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;
      if (error) {
        var _error = this.props.translations.en.error;
        return React.createElement("h1", {
          dangerouslySetInnerHTML: {
            __html: _error.general
          },
          style: {
            textAlign: 'center'
          }
        });
      }
      var _this$props = this.props,
        onSuccessRecover = _this$props.onSuccessRecover,
        onSuccessRecoverButtonClick = _this$props.onSuccessRecoverButtonClick,
        onBackToSignInClick = _this$props.onBackToSignInClick,
        onContactSupportClick = _this$props.onContactSupportClick,
        theme = _this$props.theme,
        customStyles = _this$props.customStyles,
        initiateWithCaptcha = _this$props.initiateWithCaptcha,
        hideUserError = _this$props.hideUserError,
        hideLockdownChatIcon = _this$props.hideLockdownChatIcon,
        strongPassword = _this$props.strongPassword,
        customPasswordValidation = _this$props.customPasswordValidation,
        isCaptchaInvisible = _this$props.isCaptchaInvisible,
        mobilePhoneRecoveryOnly = _this$props.mobilePhoneRecoveryOnly;
      var extendedTheme = createExtendedTheme(theme, customStyles);
      return React.createElement(Provider, {
        store: store
      }, React.createElement(TranslateProvider, null, React.createElement(ThemeProvider, {
        style: extendedTheme
      }, React.createElement("div", {
        className: "password-recovery-container"
      }, React.createElement(PasswordRecovery, {
        onSuccessRecover: onSuccessRecover,
        onSuccessRecoverButtonClick: onSuccessRecoverButtonClick,
        onBackToSignInClick: onBackToSignInClick,
        onContactSupportClick: onContactSupportClick,
        initiateWithCaptcha: initiateWithCaptcha,
        hideUserError: hideUserError,
        hideLockdownChatIcon: hideLockdownChatIcon,
        strongPassword: strongPassword,
        customPasswordValidation: customPasswordValidation,
        isCaptchaInvisible: isCaptchaInvisible,
        mobilePhoneRecoveryOnly: mobilePhoneRecoveryOnly
      })))));
    }
  }]);
  return PasswordRecoveryApp;
}(React.PureComponent);
_defineProperty(PasswordRecoveryApp, "defaultProps", {
  apiUrl: 'password-recovery-api',
  phoneNumberFormat: /([0-9]{10})/,
  captchaApiKey: 'CAPTCHA_KEY_HERE',
  captchaLanguage: 'CAPTCHA_LANGUAGE_HERE',
  onSuccessRecover: function onSuccessRecover() {
    return console.warn('Password Recovery component: onSuccessRecover missing prop');
  },
  onSuccessRecoverButtonClick: function onSuccessRecoverButtonClick() {
    return console.warn('Password Recovery component: onSuccessRecoverButtonClick missing prop');
  },
  onBackToSignInClick: function onBackToSignInClick() {
    return console.warn('Password Recovery component: onBackToSignInClick missing prop');
  },
  onContactSupportClick: function onContactSupportClick() {
    return console.warn('Password Recovery component: onContactSupportClick missing prop');
  },
  initiateWithCaptcha: false,
  translations: defaultTranslations,
  theme: null,
  customStyles: null,
  fieldsProps: {},
  hideUserError: false,
  hideLockdownChatIcon: false,
  strongPassword: true,
  customPasswordValidation: null,
  mobilePhoneRecoveryOnly: false
});
export { PasswordRecoveryApp as default };